import { Duration, IANAZone } from "luxon";
import {
  SiteGeneralSettingsModel,
  SiteInfoModel,
  UpdateSiteDTO,
} from "src/app/api/api-types";
import { SiteStatus } from "src/app/core/sites/site-status.model";
import { parseDuration } from "src/utils";

export class EditSiteModel {
  public constructor(args: ClassProperties<EditSiteModel>) {
    this.displayName = args.displayName;
    this.isManagedReceivingSite = args.isManagedReceivingSite;
    this.name = args.name;
    this.rfidNonResponsiveHours = args.rfidNonResponsiveHours;
    this.rfidFoundNotOnComplex = args.rfidFoundNotOnComplex;
    this.status = args.status;
    this.timeZone = args.timeZone;
  }

  public readonly displayName: string;
  public readonly isManagedReceivingSite: boolean;
  public readonly name: string;
  public readonly rfidNonResponsiveHours: Duration;
  public readonly rfidFoundNotOnComplex: Duration;
  public readonly status: SiteStatus;
  public readonly timeZone: IANAZone;

  public static deserialize(
    data: SiteGeneralSettingsModel & SiteInfoModel,
  ): EditSiteModel {
    return new EditSiteModel({
      ...data,
      timeZone: IANAZone.create(data.timeZone),
      rfidFoundNotOnComplex: parseDuration(data.rfidFoundNotOnComplex, "hours"),
      rfidNonResponsiveHours: parseDuration(
        data.rfidNonResponsiveHours,
        "hours",
      ),
      status: SiteStatus.deserialize(data.siteStatus),
    });
  }

  public serialize(): UpdateSiteDTO {
    return {
      displayName: this.displayName,
      isManagedReceivingSite: this.isManagedReceivingSite,
      rfidNonResponsiveHours: this.rfidNonResponsiveHours.as("hour"),
      rfidFoundNotOnComplex: this.rfidFoundNotOnComplex.as("hour"),
      timeZone: this.timeZone.name,
      siteStatusId: this.status.id,
    };
  }
}
